module.exports = __webpack_public_path__ + "static/media/visa.0cc81004.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsTable/images/visa.svg
// module id = 656
// module chunks = 0